const { ref } = Vue
import { className, Grid, h, html as htmlGrid } from 'gridjs'
import ConfirmModal from '../components/ConfirmModal.js'
import ModalAprovacao from '../components/ModalAprovacao.js'
import { emailFundacaoService } from '../services/email-fundacao.service.js'
import { fundacaoService } from '../services/fundacao.service.js'
import SelectMultiple from '../components/SelectMultiple'
import Quill from 'quill'
import _ from 'lodash'
import atendimentoRapido from '../mixins/atendimentoRapido.js'
import { URLS } from '../constants/urls.js'

const { getChoicesActive, formatDateObject } = GLOBAL
let quill = null
const {
	getTemplatesEmail,
	getFundacoesContatos,
	sendEmail,
	getEmailEnvinhado,
	isLoading,
} = emailFundacaoService()

const { getFiltroFundacao } = fundacaoService()

const refsSelects = {}

const assinaturaTemplateEmailFundacao = `
	<p style="line-height: 0.8;"><strong>Relações com Investidores Institucionais</strong></p>\n
	<p style="line-height: 0.8;">ri@azquest.com.br</p>\n
	<p style="line-height: 0.8;">clientesinstitucionais@unifinance.com.br</p>\n
	<p style="line-height: 0.8;">Tel. (21) 3138-6514</p>\n
	<div class="header">
		<img src="https://django-unifinance.s3.us-east-1.amazonaws.com/media/imagem-unifinance.png" alt="Logo" style="width: 200px; height: auto;">
	</div>\n
	<p style="color: #B0B0B0; line-height: 0.8;">A Unifinance AAI é distribuidora exclusiva dos fundos da AZ Quest para Entidade
	Fechada de Previdência Complementar – EFPC. Instituições contratantes: BEM, BNY Mellon, Intrag e BTG Pactual.</p>\n
	<p style="line-height: 0.8;"><a href="https://www.unifinance.com.br" target="_blank">www.unifinance.com.br</a></p>\n
`

const assinaturaTemplateEmailIsmael = `
<div style="font-family: Arial, Helvetica, sans-serif; background-color: white; color: #242424; font-size: 14px; line-height: 1.5;">

  <p style="margin-top: 10px;">Estou à disposição para qualquer eventualidade.</p>

  <p style="margin-top: 10px;">Atenciosamente,</p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 14px; font-weight: bold; color: #1d252c;">
    Ismael Ramos, CFP<sup style="font-size: 10px;">®</sup>
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 13px; color: #1d252c;">
    Candidato ao CFA Nível III
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 12px; color: #1d252c;">
    <a href="mailto:ri@azquest.com.br" style="color: #1d252c;">ri@azquest.com.br</a><br>
    <a href="mailto:ismael.ramos@unifinance.com.br" style="color: #1d252c;">ismael.ramos@unifinance.com.br</a>
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 12px; color: #1d252c;">
    Tel: (21) 3138-6506 / (21) 97173-1290
  </p>

  <p>
	<div class="header">
		<img src="https://django-unifinance.s3.us-east-1.amazonaws.com/media/imagem-unifinance.png" alt="Logo" style="width: 200px; height: auto;">
	</div>
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 10pt; color: #7f7f7f;">
    A Unifinance AAI é distribuidora exclusiva dos fundos da AZ Quest para Entidades Fechadas de Previdência Complementar – EFPC. Instituições contratantes: BEM, BNY Mellon, Intrag e BTG Pactual.
  </p>

   <a href="www.unifinance.com.br" style="margin-top: 10px;">www.unifinance.com.br</a>
</div>

`

const assinaturaTemplateEmailMatheus = `
	<div style="font-family: Arial, Helvetica, sans-serif; background-color: white; color: #242424; font-size: 14px; line-height: 1.5;">

  <p style="margin-top: 10px;">Estou à disposição para qualquer eventualidade.</p>

  <p style="margin-top: 10px;">Atenciosamente,</p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 14px; font-weight: bold; color: #1d252c;">
    Matheus Giannini<sup style="font-size: 10px;">®</sup>
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 12px; color: #1d252c;">
    <a href="mailto:ri@azquest.com.br" style="color: #1d252c;">ri@azquest.com.br</a><br>
    <a href="matheus@unifinance.com.br" style="color: #1d252c;">matheus@unifinance.com.br</a>
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 12px; color: #1d252c;">
    Tel: (21) 3138-6514
  </p>

  <p>
	<div class="header">
		<img src="https://django-unifinance.s3.us-east-1.amazonaws.com/media/imagem-unifinance.png" alt="Logo" style="width: 200px; height: auto;">
	</div>
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 10pt; color: #7f7f7f;">
    A Unifinance AAI é distribuidora exclusiva dos fundos da AZ Quest para Entidades Fechadas de Previdência Complementar – EFPC. Instituições contratantes: BEM, BNY Mellon, Intrag e BTG Pactual.
  </p>

  <a href="www.unifinance.com.br" style="margin-top: 10px;">www.unifinance.com.br</a>
</div>
`

export default {
	mixins: [atendimentoRapido],
	emits: [],

	props: {},
	components: {
		ModalAprovacao,
		ConfirmModal,
		SelectMultiple,
	},

	data() {
		return {
			tableEmails: [],
			listaEmail: true,
			isCreateEmail: true,
			isVisualizaEmail: false,
			isFilterFundoEmailActivate: false,
			templates: {
				results: [],
			},
			fundacoesList: {
				results: [],
			},
			emailsEnvinhados: {},
			emailVisualizacao: {
				template: '',
				fundacoes: [],
				corpo_email: '',
				assunto: '',
			},
			isLoading: isLoading,
			template: '',
			fundacoes: [],
			corpo_email: '',
			assunto: '',
			quill_visualiza: null,
			filtros: {
				fundo: [],
				tag: [],
				tempoSenAtendimentoRapido: null,
			},
			fundoOption: [],
			tagOption: [],
			tempoSenAtendimentoRapidoOption: [
				{ label: '1 a 3 meses', value: '1,3' },
				{ label: '4 a 6 meses', value: '4,6' },
				{ label: 'Mais de 6 meses', value: '6,1000' },
			],
			isValidSubmit: true,
		}
	},
	watch: {
		template() {
			const templateSelecionado = this.templates?.results?.find(
				(template) => template.id_template === parseInt(this.template)
			)

			if (!quill) return

			if (!templateSelecionado) {
				quill.root.innerHTML = ''
				this.assunto = ''
				quill.setText('')

				return
			}
			this.assunto = templateSelecionado.assunto
			quill.setText('')

			this.setDeltaToQuillByContent(templateSelecionado.corpo)

			/* this.quill.root.innerHTML =
				templateSelecionado.corpo + '<br/>' + assinaturaTemplateEmailFundacao */
		},

		fundacoes() {
			const selectFundacoes = getChoicesActive(
				'email_fundacao',
				window.listOfChoices
			)
			if (this.fundacoes.length > 1) {
				/* this.fundacoes = this.fundacoes.filter(
					(itemFundacaoSelecionada) => true
				) */

				selectFundacoes.removeActiveItemsByValue('')
			}
		},

		fundacoesList() {
			/* console.log(this.fundacoesList) */
	
			const opcoes = this.fundacoesList?.map((fundacao) => ({
				value: fundacao.id_fundacao,
				label: fundacao.sigla_fundacao,
			}))

			const selectFundacoes = getChoicesActive(
				'email_fundacao',
				window.listOfChoices
			)

			selectFundacoes.removeActiveItems()
			selectFundacoes.clearChoices()
			selectFundacoes.setChoices([{ value: '', label: 'Selecione' }, ...opcoes])

			if (this.isFilterFundoEmailActivate) {
				if (this.filtros.fundo.length > 0 || this.filtros.tag.length > 0 || this.filtros.tempoSenAtendimentoRapido) {
					opcoes.forEach(({ value }) => {
						selectFundacoes.setChoiceByValue(value)
					})
				} else {
					selectFundacoes.setChoiceByValue('')
				}

				this.fundacoes = selectFundacoes.getValue(true)
			} else {
				selectFundacoes.setChoiceByValue('')
				this.fundacoes = []
			}

			/* console.log('cliente fundo: ',this.fundacoes) */
			refsSelects.selectFundacoes = selectFundacoes

			
		},

		templates() {
			const opcoes = this.templates?.results?.map((fundacao) => ({
				value: fundacao.id_template,
				label: fundacao.assunto,
			}))

			const selectTemplates = getChoicesActive(
				'email_modelo',
				window.listOfChoices
			)

			selectTemplates.setChoices([{ value: '', label: 'Selecione' }, ...opcoes])
			selectTemplates.setChoiceByValue('')

			refsSelects.selectTemplates = selectTemplates
		},
	},
	methods: {
		initSelectTempo() {
			const selectTempo = getChoicesActive(
				'tempo_filtro_lista',
				window.listOfChoices
			)

			if (selectTempo) {
				selectTempo.setChoices([
					{ value: '', label: 'Selecione' },
					...this.tempoSenAtendimentoRapidoOption,
				])
				selectTempo.setChoiceByValue('')
			}
		},
		checkCamposIsValid() {
			const fundacoesFiltrado = this.filtrarFundacoesValid()
			const texto = quill.getText()
			const isConteudoCorpoVazio = texto.trim().length === 0

			if (
				fundacoesFiltrado.length > 0 &&
				this.template &&
				this.assunto &&
				!isConteudoCorpoVazio
			) {
				this.isValidSubmit = false
			} else {
				this.isValidSubmit = true
			}
		},

		setDeltaToQuillByContent(content) {
			const delta = quill.clipboard.convert({ html: content })

			quill.setContents(delta, 'silent')
			quill.setSelection(0, 0, 'silent')
			quill.focus()
		},

		filtrarFundacoesValid() {
			return this.fundacoes
				.filter((itemFundacao) => itemFundacao !== '')
				.map((itemFundacao) => parseFloat(itemFundacao))
		},

		async onSubmit() {
			const fundacoesFiltrado = this.filtrarFundacoesValid()
			let template = ''
			const atualUsuario = GLOBAL.usuario.nome

			if (atualUsuario.toLowerCase() === 'ismael') {
				template = assinaturaTemplateEmailIsmael
			} else if (atualUsuario.toLowerCase() === 'matheus') {
				template = assinaturaTemplateEmailMatheus
			} else {
				template = assinaturaTemplateEmailFundacao
			}

			const conteudoCorpo = quill.getSemanticHTML() + '<br/>' + template

			const data = {
				template_id: this.template,
				clientes_ids: fundacoesFiltrado,
				corpo: conteudoCorpo,
			}

			const responseEmail = await sendEmail(data, '')

			this.atualizaTableEmails()
			/* this.closeCreateEmail() */

			const responseAtendimentoRapido = await this.createAtendimentoRapido(
				'0',
				quill.getSemanticHTML()
			)

			window.location.href = `${
				window.location.origin
			}/clientes/email_fundacao/?t=${new Date().getTime()}`
		},

		openCreateEmail() {
			this.listaEmail = false
			this.isCreateEmail = true
		},

		openVisualizaEmail() {
			this.listaEmail = false
			this.isCreateEmail = false
			this.isVisualizaEmail = true
		},

		closeCreateEmail() {
			this.listaEmail = true
			this.isCreateEmail = true
			this.clearCamposEnvioEmail()
			this.clearClienteAtendimentoRapido()
		},

		closeVisualizarEmail() {
			this.listaEmail = true
			this.isCreateEmail = true
			this.isVisualizaEmail = false
		},

		/* 		limpaFormEnvioEmail() {
			refsSelects.selectTemplates.setChoiceByValue('')
			refsSelects.selectFundacoes.setChoiceByValue('')
			this.assunto = ''
			this.quill.root.innerHTML = ''
		},
 */
		openModalEmailFundacao() {
			modal_padrao_vue.openModal('email_fundacao_filtros')
		},

		updateCorpoEmail() {
			if (!quill) {
				return
			}
			quill.on('text-change', () => {
				const html = quill.root.innerHTML
				this.corpo_email = html
			})
		},

		clearCamposEnvioEmail() {
			const selectFundacoes = getChoicesActive(
				'email_fundacao',
				window.listOfChoices
			)

			const selectTemplates = getChoicesActive(
				'email_modelo',
				window.listOfChoices
			)

			selectFundacoes.removeActiveItems()
			selectFundacoes.setChoiceByValue('')
			selectTemplates.removeActiveItems()

			this.fundacao = ''
			this.template = ''
			this.assunto = ''
			quill.setText('', 'silent')
			const length = quill.getLength()
			quill.deleteText(0, length, 'silent')
			quill.setSelection(0, 0, 'silent')
		},

		iniciarTabelaGenerica(
			tableSelector,
			columns,
			url,
			customThenCallback,
			customTotalCallback
		) {
			const table = document.querySelector(tableSelector)

			const gridInstance = new Grid({
				search: true,
				resizable: true,
				columns: columns,
				data: [],
				autoWidth: true,
				width: '100%',
				sort: false,
				server: {
					url: url,
					then: (data) => customThenCallback(data),
					total: (data) => customTotalCallback(data),
				},
				pagination: {
					enabled: true,
					limit: 10,
					summary: false,
					server: {
						url: (urlApi, page, limit) =>
							`${urlApi}&page=${++page}&paginate_by=${limit}`,
					},
				},
				style: {
					container: { border: 'none' },
					table: { border: 'none' },
					tr: { border: 'none' },
					th: { 'border-bottom': '1px solid #e9ecef' },
					td: {
						'border-bottom': '1px solid #e9ecef',
						cursor: 'pointer',
						color: '#495057',
						'font-family': 'Roboto Flex',
						'font-size': '14px',
						'font-weight': 500,
						'line-height': '150%',
						'letter-spacing': '-0.28px',
					},
					footer: { border: 'none' },
				},
				language: {
					search: { placeholder: 'Busque aqui...' },
					pagination: { previous: ' Anterior', next: 'Próximo ' },
				},
			})

			gridInstance.render(table)
			return gridInstance
		},

		iniciartableEmails() {
			const columns = [
				{ id: 'ID', name: 'ID', hidden: true, width: '100px' },

				{ id: 'Para', name: 'Para', width: '10rem' },

				{ id: 'Assunto', name: 'Assunto', hidden: false },
				{
					id: 'Enviados',
					name: 'Enviados',
					formatter: (cell) => this.formatDataEmail(cell),
				},

				{
					id: 'acao',
					name: '',
					width: '80px',
					formatter: (cell, row) => this.renderHistoricoAcoes(row),
				},
			]

			this.tableEmails = this.iniciarTabelaGenerica(
				'#table_emails',
				columns,
				`${window.origin}${URLS.email_enviados}?`,
				(data) => this.mapAndFilterSolicitations(data),
				(data) => this.getTotalEmails(data)
			)
		},

		atualizaTableEmails() {
			this.tableEmails
				.updateConfig({
					server: {
						url: `${window.origin}/clientes/email_enviados/?t=${Date.now()}`,
						then: (data) => this.mapAndFilterSolicitations(data),
						total: (data) => this.getTotalEmails(data),
					},
				})
				.forceRender()
		},

		mapAndFilterSolicitations(data) {
			const listaEmailsEnvinhados = data?.results || []
			this.emailsEnvinhados = listaEmailsEnvinhados
			const emailsEnvinhadosTransformados = listaEmailsEnvinhados.map(
				(emailEnvinhado) => {
					return {
						ID: emailEnvinhado?.id,
						Assunto: emailEnvinhado?.assunto,
						Para: emailEnvinhado?.enviado_para,
						Enviados: emailEnvinhado?.enviado_em,
					}
				}
			)

			/* 			console.log(emailsEnvinhadosTransformados) */

			return emailsEnvinhadosTransformados
		},

		getTotalEmails(data) {
			/* console.log(data.count) */

			return data.count
		},

		formatDataEmail(data) {
			return formatDateObject(new Date(data))
		},

		renderAcoes(row) {
			return h(
				'div',
				{
					className: 'flex gap-2 justify-between',
				},
				[
					h('ion-icon', {
						name: 'checkmark-outline',
						className: 'success',
						onClick: () => this.openModalSolicitacao(row, 'aprovar'),
					}),
					h('ion-icon', {
						name: 'close-outline',
						className: 'error',
						onClick: () => this.openModalSolicitacao(row, 'recusar'),
					}),
				]
			)
		},

		renderHistoricoAcoes(row) {
			return h('ion-icon', {
				name: 'search-outline',
				onClick: async () => await this.getInfoEmailEnvinhado(row),
			})
		},

		async getInfoEmailEnvinhado(row) {
			const idEmail = row?._cells[0]?.data

			/* const atualEmailVisualizado = this.emailsEnvinhados.find(
				(emailEnvinhado) => emailEnvinhado.id === idEmail
			) */

			const atualEmailVisualizado = (await getEmailEnvinhado(idEmail))
				?.results[0]

			if (atualEmailVisualizado) {
				/* console.log(atualEmailVisualizado) */

				const opcoesFundacoes = [
					{
						label: atualEmailVisualizado?.enviado_para,
						value: atualEmailVisualizado?.envinhado_para_id,
					},
				]

				const selectFundacoes = getChoicesActive(
					'email_fundacao_visualisa',
					window.listOfChoices
				)

				selectFundacoes.removeActiveItems()
				selectFundacoes.clearChoices()

				selectFundacoes.setChoices([
					{ value: '', label: 'Selecione' },
					...opcoesFundacoes,
				])

				const opcoesTemplates = this.templates?.results?.map((fundacao) => ({
					value: fundacao.id_template,
					label: fundacao.assunto,
				}))

				const selectTemplates = getChoicesActive(
					'email_modelo_visualisa',
					window.listOfChoices
				)

				selectTemplates.setChoices([
					{ value: '', label: 'Selecione' },
					...opcoesTemplates,
				])
				/* console.log(atualEmailVisualizado.envinhado_para_id) */

				selectFundacoes.setChoiceByValue([
					atualEmailVisualizado.envinhado_para_id,
				])
				selectTemplates.setChoiceByValue(atualEmailVisualizado.template_id)

				this.emailVisualizacao.assunto = atualEmailVisualizado.assunto

				this.quill_visualiza.root.innerHTML =
					atualEmailVisualizado.corpo_alterado || atualEmailVisualizado.corpo

				/* selectTemplates.setChoiceByValue('1') 
			this.emailVisualizacao.template = 1; */
				/* this.emailVisualizacao = {
				template: '1',
				fundacoes: [atualEmailVisualizado.envinhado_para_id],
				corpo_email: '',
				assunto: '',
			} */

				this.openVisualizaEmail()
			}
		},

		async getInfoFundacoesFiltro() {
			let responseFundacoesFundo = []
			let responseFundacoesTag = []
			let fundacoesUnificado = []
			let responseFundacoesTempo = []

			if (this.filtros.fundo && this.filtros.fundo.length > 0) {
				responseFundacoesFundo =
					(await this.getFundacoesFiltroQuery('fundo')) || []
			}

			if (this.filtros.tag && this.filtros.tag.length > 0) {
				responseFundacoesTag = (await this.getFundacoesFiltroQuery('tag')) || []
			}

			if (this.filtros.tempoSenAtendimentoRapido) {
				responseFundacoesTempo =
					(await this.getFundacoesFiltroQuery('tempo')) || []
			}

			const temFiltroFundo = this.filtros.fundo && this.filtros.fundo.length > 0
			const temFiltroTag = this.filtros.tag && this.filtros.tag.length > 0
			const temFiltroTempo = this.filtros.tempoSenAtendimentoRapido

			if (!temFiltroFundo && !temFiltroTag && !temFiltroTempo) {
				fundacoesUnificado = (await this.getFundacoesFiltroQuery('all')) || []
			} else {
				let resultadosCombinados = []

				if (temFiltroFundo)
					resultadosCombinados = resultadosCombinados.concat(
						responseFundacoesFundo
					)
				if (temFiltroTag)
					resultadosCombinados =
						resultadosCombinados.concat(responseFundacoesTag)
				if (temFiltroTempo)
					resultadosCombinados = resultadosCombinados.concat(
						responseFundacoesTempo
					)

				fundacoesUnificado = resultadosCombinados

				
			}

			this.fundacoesList = _.unionBy(
				fundacoesUnificado,
				(itemFundacao) => `${itemFundacao?.id_fundacao}`
			)

			this.isFilterFundoEmailActivate = true
		},

		async getFundacoesFiltroQuery(campo) {
			const paramsUrl = new URLSearchParams()

			if (campo !== 'tempo' && campo !== 'all' && this.filtros[campo]) {
				paramsUrl.append(
					campo,
					this.filtros[campo].map((itemFiltro) => itemFiltro.value).join(',')
				)
			}


			if (this.filtros.tempoSenAtendimentoRapido) {
				paramsUrl.append(
					'meses_sem_atendimento',
					this.filtros.tempoSenAtendimentoRapido
				)
			}

			const queryFiltroFundacao =
				paramsUrl.size > 0 ? `?${paramsUrl.toString()}` : ''

			return await getFundacoesContatos(queryFiltroFundacao)
		},

		async initSelectFiltros() {
			const listaFiltroFundacao = await getFiltroFundacao()

			/* const fundoChoise = getChoicesActive(
				'fundo_filtro_lista',
				window.listOfChoices
			) */

			/* const tagChoise = getChoicesActive(
				'tag_filtro_lista',
				window.listOfChoices
			) */

			/* 	fundoChoise.setChoices(
				listaFiltroFundacao?.fundos?.map((itemFiltroFundacao) => {
					return {
						value: itemFiltroFundacao[1],
						label: itemFiltroFundacao[1],
					}
				})
			)
 */
			this.fundoOption = listaFiltroFundacao?.fundos?.map(
				(itemFiltroFundacao) => ({
					value: itemFiltroFundacao[1],
					label: itemFiltroFundacao[1],
				})
			)

			/* tagChoise.setChoices(
				listaFiltroFundacao?.tags?.map((itemFiltroFundacao) => {
					return {
						value: itemFiltroFundacao[0],
						label: itemFiltroFundacao[1],
					}
				})
			) */

			this.tagOption = listaFiltroFundacao?.tags?.map((itemFiltroTag) => ({
				value: itemFiltroTag[0],
				label: itemFiltroTag[1],
			}))
		},

		async limparFiltrosFundos() {
			window.location = `${window.origin}/clientes/email_fundacao/`
		},

		eventoAddFundacoes() {
			const selectFundacoes = getChoicesActive(
				'email_fundacao',
				window.listOfChoices
			)

			selectFundacoes.passedElement.element.addEventListener(
				'addItem',
				(event) => {
					this.addClienteAtendimentoRapido(event.detail.value)
				}
			)
		},

		eventoDeletaFundacoes() {
			const selectFundacoes = getChoicesActive(
				'email_fundacao',
				window.listOfChoices
			)

			selectFundacoes.passedElement.element.addEventListener(
				'removeItem',
				(event) => {
					this.removeClienteAtendimentoRapido(event.detail.value)
				}
			)
		},

		initEventosSelect() {
			this.eventoAddFundacoes()
			this.eventoDeletaFundacoes()
			this.initSelectTempo()
		},
	},

	created() {
		this.$watch(
			() => [this.fundacoes, this.template, this.assunto],
			() => {
				this.checkCamposIsValid()
			}
		)
	},

	async mounted() {
		quill = new Quill(this.$refs.editor, {
			theme: 'snow',
			modules: {
				toolbar: [
					[{ header: [1, 2, false] }],
					['bold', 'italic', 'underline'],
					[{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
					[{ color: [] }, { background: [] }],
					['clean', 'image'],
				],
			},
		})

		this.quill_visualiza = new Quill(this.$refs.editor_visualisa, {
			theme: 'snow',
			readOnly: true,
			modules: {
				toolbar: [
					[{ header: [1, 2, false] }],
					['bold', 'italic', 'underline'],
					[{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
					[{ color: [] }, { background: [] }],
					['clean', 'image'],
				],
			},
		})

		this.updateCorpoEmail()

		this.fundacoesList = await getFundacoesContatos()
		this.templates = await getTemplatesEmail()

		await this.initSelectFiltros()

		this.iniciartableEmails()

		this.initEventosSelect()
	},
	delimiters: ['{*', '*}'],
}
